export default "__VITE_ASSET__CXcQIS1m__"